'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    PositioningConfigurationProvider: function() {
        return PositioningConfigurationProvider;
    },
    usePositioningConfiguration: function() {
        return usePositioningConfiguration;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
// ---
const DEFAULT_CONFIGURATION = ({ options })=>{
    return options;
};
// ---
const PositioningConfigurationContext = /*#__PURE__*/ _react.createContext(undefined);
const PositioningConfigurationProvider = PositioningConfigurationContext.Provider;
const usePositioningConfiguration = ()=>{
    var _React_useContext;
    return (_React_useContext = _react.useContext(PositioningConfigurationContext)) !== null && _React_useContext !== void 0 ? _React_useContext : DEFAULT_CONFIGURATION;
};
